module.exports = __webpack_public_path__ + "static/media/tasaa-logo.6f0ec17b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/tasaa-logo.png
// module id = 974
// module chunks = 0